import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    scrollIndicator: {
        position: 'absolute',
        bottom: theme.spacing(4),
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        animation: '$bounce 2s infinite',
        cursor: 'pointer',
        zIndex: 10,
    },
    '@keyframes bounce': {
        '0%, 20%, 50%, 80%, 100%': {
            transform: 'translateX(-50%) translateY(0)',
        },
        '40%': {
            transform: 'translateX(-50%) translateY(-10px)',
        },
        '60%': {
            transform: 'translateX(-50%) translateY(-5px)',
        },
    },
    text: {
        fontSize: '0.75rem',
        marginBottom: theme.spacing(0.5),
        opacity: 0.7,
    },
    icon: {
        fontSize: '1.5rem',
        opacity: 0.7,
    },
}));

export const ScrollIndicator = () => {
    const classes = useStyles();

    const handleClick = () => {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth',
        });
    };

    return (
        <Box className={classes.scrollIndicator} onClick={handleClick}>
            <span className={classes.text}>Scroll Down</span>
            <KeyboardArrowDown className={classes.icon} />
        </Box>
    );
};

